import { IPublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";

export const getToken = async (msalInstance: IPublicClientApplication, scope: any) => {
  console.log("Initializing MSAL instance");
  const init = await msalInstance.initialize();
  console.log("MSAL instance initialized:", init);

  const activeAccount = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();

  console.log("Active account:", activeAccount);
  console.log("All accounts:", accounts);

  if (!activeAccount && accounts.length === 0) {
    console.log("No active account and no accounts available");
    return "";
  }

  const request = {
    scopes: [(scope !== null || "") ? scope : process.env.REACT_APP_AZURE_CLIENTID + "/.default"],
    account: activeAccount || accounts[0]
  };

  console.log("Request object:", request);

  try {
    const authResult = await msalInstance.acquireTokenSilent(request);
    console.log("Acquired token silently:", authResult.accessToken);
    return authResult.accessToken;
  } catch (error) {
    console.log("Silent token acquisition fails. Acquiring token using popup", error);

    if (error instanceof InteractionRequiredAuthError) {
      try {
        const tokenResponse = await msalInstance.acquireTokenPopup(request);
        console.log("Acquired token via popup:", tokenResponse.accessToken);
        return tokenResponse.accessToken;
      } catch (popupError) {
        console.error("Popup token acquisition failed:", popupError);
        return "";
      }
    } else {
      console.error("Token acquisition error:", error);
      return "";
    }
  }
};
